import { render, staticRenderFns } from "./PackageSelector.vue?vue&type=template&id=62a8378e"
import script from "./PackageSelector.vue?vue&type=script&lang=js"
export * from "./PackageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports